import React, { useState, useEffect } from 'react';
import { BottomNavigation, BottomNavigationAction, Paper, Box, Typography } from '@mui/material';
import { MdChatBubbleOutline, MdPeopleOutline } from 'react-icons/md';
import { FaRobot } from 'react-icons/fa';
import { AiOutlinePlus } from 'react-icons/ai';
import { getCurrentIdentity } from './userIdentity';
import { CgProfile } from 'react-icons/cg';
import { useNavigate, Routes, Route, useLocation } from 'react-router-dom';

// Компоненты
import Chats from './components/Chats';
import Bots from './components/Bots';
import CreateBot from './components/CreateBot';
import Profile from './components/Profile';
import TelegramLinkButton from './components/TelegramLinkButton';
import BotProfile from './components/BotProfile';
import Chat from './components/Chat';
import Groups from './components/Groups';
import GroupProfile from './components/GroupProfile';


function App() {
  const location = useLocation();
  const navigate = useNavigate();
  const [value, setValue] = useState(0);
  const [isBanned, setIsBanned] = useState(false);
  const [loading, setLoading] = useState(true);




  // 1. Проверка бана при загрузке
  useEffect(() => {
    const checkBanStatus = async () => {
      if (window.Telegram && window.Telegram.WebApp) {
        const tg = window.Telegram.WebApp;
        tg.ready();
        tg.expand();
        tg.setBackgroundColor('#121212');
        tg.setHeaderColor('#1e1e1e');
      }

      try {
        const identity = await getCurrentIdentity();

        if (identity?.userId) {
          const response = await fetch(`/api/profile/${identity.userId}`);
          const data = await response.json();

          if (data.isBanned === 1) {
            setIsBanned(true);
          }
        }
      } catch (error) {}

      setLoading(false);
    };

    checkBanStatus();
  }, []);



  const handleChange = (event, newValue) => {
    navigate(newValue);
  };

  // Если идет загрузка данных профиля
  if (loading) return <div style={{height:'100vh',background:'#121212'}} />;

  // 2. ЭКРАН БАНА (Пункт 4)
  if (isBanned) {
    return (
      <Box sx={{ 
        height: '100vh', 
        display: 'flex', 
        alignItems: 'center', 
        justifyContent: 'center', 
        backgroundColor: '#121212',
        textAlign: 'center',
        p: 3
      }}>
        <Typography variant="h4" sx={{ color: 'white', fontWeight: 'bold' }}>
          Вы в бане
        </Typography>
      </Box>
    );
  }

  // Скрываем нижнее меню, когда открыт конкретный чат
  const isChatOpen = location.pathname.startsWith('/chat/');

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', height: '100vh', overflow: 'hidden', backgroundColor: '#121212' }}>
      
      {/* Контентная область */}
      <Box sx={{ 
        flex: 1, 
        overflowY: 'auto', 
        // Если чат открыт, убираем отступ снизу
        pb: isChatOpen ? 0 : '70px', 
        transition: 'all 0.3s ease' 
      }}>
        <Routes>
          <Route path="/" element={<Chats />} />
          <Route path="/chats" element={<Chats />} />
          <Route path="/bots" element={<Bots />} />
          <Route path="/create" element={<CreateBot />} />
          <Route path="/groups" element={<Groups />} />
          <Route 
            path="/group/:chatId" 
            element={<GroupProfileWithIdentity />} 
          />
          <Route path="/profile" element={<Profile />} />
          <Route path="/profile/:userId" element={<Profile />} />
          <Route path="/bot/:id" element={<BotProfile />} />
          <Route path="/chat/:chatId" element={<Chat />} />
        </Routes>
      </Box>

      {/* Нижнее меню (скрывается в чате) */}
      {!isChatOpen && (
        <Paper sx={{ position: 'fixed', bottom: 0, left: 0, right: 0, zIndex: 1100 }} elevation={3}>
          <BottomNavigation 
            value={location.pathname === '/' ? '/chats' : location.pathname} 
            onChange={handleChange} 
            showLabels
            sx={{ backgroundColor: '#1e1e1e', '& .Mui-selected': { color: '#007AFF' } }}
          >
            <BottomNavigationAction value="/chats" label="Чаты" icon={<MdChatBubbleOutline size={22} />} sx={{ color: '#888' }} />
            <BottomNavigationAction value="/bots" label="Боты" icon={<FaRobot size={22} />} sx={{ color: '#888' }} />
            <BottomNavigationAction value="/create" icon={<AiOutlinePlus size={28} />} sx={{ color: '#888' }} />
            <BottomNavigationAction value="/groups" label="Группы" icon={<MdPeopleOutline size={22} />} sx={{ color: '#888' }} />
            <BottomNavigationAction value="/profile" label="Профиль" icon={<CgProfile size={22} />} sx={{ color: '#888' }} />
          </BottomNavigation>
        </Paper>
      )}
      <TelegramLinkButton />
    </Box>
  );
}

// Временная обертка в App.js или прямое исправление в GroupProfile:
function GroupProfileWithIdentity() {
  const [userId, setUserId] = useState(null);

  useEffect(() => {
    getCurrentIdentity().then(identity => {
      if (identity?.userId) setUserId(identity.userId);
    });
  }, []);

  if (!userId) return <div style={{color: '#fff', padding: 20}}>Загрузка...</div>;

  return <GroupProfile currentUserId={userId} />;
}

export default App;